import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  label {
    font-family: 'InterBold', sans-serif;
    font-size: 16px;
    line-height: 20px;
    color: #828282;
    margin-bottom: 8px;
  }
  
  a {
    max-width: 150px !important;
  }


  a + a {
    margin-left: 10px;
  }
`;

export const ActionButton = styled.a`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  text-align: center;

  font-family: 'PoppinsSemiBold',sans-serif;
  font-size: 16px;
  line-height: 20px;
  text-decoration: none;

  background-color: #26a2b1;
  color: #ffffff;

  width: 100%;
  max-width: 150px;

  padding: 16px 0;
  margin: 0;
  border-radius: 3px;
  
  cursor: pointer;    
`;
